import { formatDateTime } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";

import { type InterviewWithDetails } from "../../WorkerShifts/api/useFetchPaginatedInterviews";
import { type PlacementDetail } from "../api/useGetPlacement";
import { type PrimaryActionParams } from "../components/PlacementApplyButton/utils/getPrimaryAction";

type ActionParamsFromConnectedListingInterviewAndPlacement = Pick<
  PrimaryActionParams,
  | "hasConnectedListingInterview"
  | "connectedListingInterviewStartTime"
  | "connectedListingHiringManagerName"
  | "isConnectedListingInterviewInOtherWorkplace"
  | "connectedListingInterviewWorkplaceName"
>;
export function getActionParamsFromConnectedListingPlacementAndInterview(
  placement: PlacementDetail,
  workerTimezone: string,
  connectedInterview?: InterviewWithDetails
): ActionParamsFromConnectedListingInterviewAndPlacement {
  const hasConnectedListingInterview = isDefined(connectedInterview);

  if (!hasConnectedListingInterview) {
    return { hasConnectedListingInterview };
  }

  const hiringManager = placement.hiringManagers?.find((manager) => manager.isPrimary);

  const connectedListingHiringManagerName = isDefined(hiringManager)
    ? hiringManager?.attributes.name
    : undefined;

  const connectedListingInterviewStartTime = formatDateTime(connectedInterview.start, {
    timeZone: workerTimezone,
  });

  const isConnectedListingInterviewInOtherWorkplace =
    isDefined(connectedInterview.workplace) &&
    connectedInterview?.workplace?.id !== placement.workplace.id;

  const connectedListingInterviewWorkplaceName = connectedInterview.workplace?.name;

  return {
    hasConnectedListingInterview,
    connectedListingInterviewStartTime,
    connectedListingHiringManagerName,
    isConnectedListingInterviewInOtherWorkplace,
    connectedListingInterviewWorkplaceName,
  };
}
